/* global rootUrl:true */
// const Urls = { ROOT_URL: rootUrl, API_ROOT: `${rootUrl}api` };
const Urls = {
    ROOT_URL: process.env.REACT_APP_ROOT,
    API_ROOT: process.env.REACT_APP_ENTERPRISE_API,
};

export default function getUri(path) {
    // return `${Urls.API_ROOT}/${path}`;
    return `api/${path}`;
}

export function getNonApiUri(path) {
    // return `${Urls.ROOT_URL}${path}`;
    return `/${path}`;
}

export function getMultiSystemUri(path, destinationSystemKey, systemManifest) {
    const systemOrigin = systemManifest.find(
        (x) => x.destinationSystemKey === destinationSystemKey
    )?.systemOrigin;
    return `${systemOrigin}/api/${path}`;
}

export function getMultiSystemNonApiUri(
    path,
    destinationSystemKey,
    systemManifest
) {
    const systemOrigin = systemManifest.find(
        (x) => x.destinationSystemKey === destinationSystemKey
    )?.systemOrigin;
    return `${systemOrigin}/${path}`;
}

export function getPageHelpUri(pageIdentifier) {
    if (!pageIdentifier || !pageIdentifier.helpPageUrl || !pageIdentifier.onlineHelpId) {
        return null;
    }

    return `${pageIdentifier.helpPageUrl}${pageIdentifier.onlineHelpId}`;
}
